<template>
  <div id="commodityIndex" class="aside-menu-to-content">
    <div class="secondary-menu-container">
      <div class="secondary-menu-title">订单</div>
      <second-menu :secondaryMenuMap="secondaryMenuMap"></second-menu>
    </div>
    <div class="content-container">
      <!-- 二级菜单渲染入口 -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script >
import { getDBOperationPermission } from "common/js/storage";
// 页面二级菜单
import SecondMenu from "components/layout/SecondMenu";
// 系统首页 二级菜单路由表
export default {
  data() {
    return {
      secondaryMenuMap: [
        {
          menuName: "选品单",
          url: "/supplier/spl-order/select-order",
          childrenMenu: [],
        },
        {
          menuName: "购样单",
          url: "/supplier/spl-order/sample-from",
          childrenMenu: [],
        },
      ],
      authorityList: "",
    };
  },
  methods: {},
  components: {
    SecondMenu,
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "common/styles/aside-menu-to-content.scss";
</style>
